// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:41:38

export default {
  "id": "weaponsmith-evolution-weapon-merge",
  "slug": "weaponsmith-evolution-weapon-merge",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/683d89ac64614cc8a82f5d562abb2073-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/683d89ac64614cc8a82f5d562abb2073/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Weaponsmith Evolution - Weapon Merge",
      "description": "- Start with basic weapons and drag identical ones to merge them into more powerful versions.\n- Each new weapon brings more gold.\n- Spend gold on upgrades: unlock new types of weapons or speed up the merging process.\n- Fight monsters and progress through levels.\n- From time to time, you’ll encounter powerful bosses. Defeat them to prove your mastery!",
      "instructions": "- Start with basic weapons and drag identical ones to merge them into more powerful versions.\n- Each new weapon brings more gold.\n- Spend gold on upgrades: unlock new types of weapons or speed up the merging process.\n- Fight monsters and progress through levels.\n- From time to time, you’ll encounter powerful bosses. Defeat them to prove your mastery!",
      "genres": [
        "Merge"
      ],
      "tags": [
        "1player"
      ]
    },
    "zh-CN": {
      "title": "武器锻造进化 - 武器融合",
      "description": "- 从基础武器开始，拖动相同的武器合并成更强大的版本。\n- 每种新武器都能带来更多金币。\n- 用金币进行升级：解锁新类型的武器或加速合并过程。\n- 与怪物战斗，通过关卡。\n- 不时地，你会遇到强大的Boss。击败他们来证明你的掌控力！",
      "instructions": "- 从基本的武器开始，拖动相同的武器合并成更强大的版本。\n- 每种新武器都会带来更多的金币。\n- 用金币进行升级：解锁新的武器类型或加速合并过程。\n- 与怪物战斗，通过关卡。\n- 不时你会遇到强大的Boss。击败他们来证明你的掌控力！",
      "genres": [
        "合并"
      ],
      "tags": [
        "1玩家"
      ]
    },
    "zh-TW": {
      "title": "武器鍛造進化 - 武器合併",
      "description": "- 從基本的武器開始，將相同的武器拖動以合併成更強大的版本。\n- 每把新武器都能帶來更多黃金。\n- 用黃金購買升級：解鎖新類型的武器或加速合併過程。\n- 和怪物戰鬥，進行等級挑戰。\n- 間隔一段時間，你將會遇到強大的頭目。擊敗他們以證明你的駕馭力！",
      "instructions": "- 從基本的武器開始，將相同的武器拖動來合併成更強大的版本。\n- 每種新的武器都會帶來更多的黃金。\n- 使用黃金進行升級：解鎖新的武器類型或加速合併過程。\n- 戰鬥怪物並通過等級。\n- 不時會遇到強大的頭目。擊敗他們以證明你的精通！",
      "genres": [
        "合併"
      ],
      "tags": [
        "1人玩家"
      ]
    },
    "zh-HK": {
      "title": "武器師進化 - 武器合併",
      "description": "- 開始使用基本武器，將相同的武器拉近合併成更強大的版本。\n- 每種新武器都會帶來更多黃金。\n- 花費黃金進行升級：解鎖新類型的武器或加速合併過程。\n- 繁敵戰鬥，進行關卡挑戰。\n- 不時會遇到強力的大頭目。擊敗他們以證明你的修為！",
      "instructions": "- 以基本武器為起點，拖動相同武器合併為更強大的版本。\n- 每新增一把武器，都可獲得更多黃金。\n- 使用黃金進行升級：解鎖新類型的武器或加速合併過程。\n- 戰鬥怪物並通過等級。\n- 不時會遇到強大的BOSS。擊敗他們以證明你的主宰力！",
      "genres": [
        "合拼"
      ],
      "tags": [
        "1人玩家"
      ]
    },
    "ja": {
      "title": "武器職人進化 - 武器融合",
      "description": "- 基本な武器から始め、同じ武器をドラッグして強力なバージョンに合体させます。\n- 新しい武器ごとに金を獲得します。\n- 金を使ってアップグレード：新しい武器の種類を解除したり、合体プロセスを速めることができます。\n- 悪魔と戦い、レベルを進みます。\n- 時折、強力なボスに出会います。彼らを倒して、あなたの達人ぶりを証明しましょう！",
      "instructions": "- 基本な武器から始め、同じ武器をドラッグして強力なバージョンに統合します。\n- 新しい武器はより多くの金を带来します。\n- 金を使ってアップグレードを行い、新しい武器の種類を解除したり、統合プロセスを速めます。\n- 怪獣と戦い、レベルを進みます。\n- その都度、強力なボスに出会います。彼らを倒してあなたのマスターさを証明せよ！",
      "genres": [
        "合体"
      ],
      "tags": [
        "1プレイヤー"
      ]
    },
    "ko": {
      "title": "무기공학 발전 - 무기 합성",
      "description": "- 기본 무기로 시작하고, 같은 무기를 끌어서 강력한 버전으로 합칩니다.\n- 새로운 무기마다 더 많은 금을 얻습니다.\n- 금을 소비하여 업그레이드하세요: 새로운 무기 유형을 해금하거나 합치는 과정을 빠르게 만듭니다.\n- 몬스터와 싸워 레벨을 통해 진행하세요.\n- 때때로 강력한 보스를 만나게 됩니다. 이들을 đánh파하여 마스터십을 증명하세요!",
      "instructions": "- 기본 무기를 사용하여 동일한 무기를 드래그하여 더 강력한 버전으로 합성하세요.\n- 새로운 무기는 더 많은 금을 가져옵니다.\n- 금을 업그레이드에 사용하세요: 새로운 무기 유형을 해금하거나 합성 과정을 가속화하세요.\n- 몬스터와 싸우고 레벨을 진행하세요.\n- 때때로 강력한 보스를 만나게 됩니다. 그들을 물리치고 마스터십을 입증하세요!",
      "genres": [
        "병합"
      ],
      "tags": [
        "1플레이어"
      ]
    },
    "fr": {
      "title": "Forgeron Évolution - Fusion d'Armes",
      "description": "- Commencez avec des armes de base et glissez les armes identiques pour les fusionner en versions plus puissantes.\n- Chaque nouvelle arme rapporte plus d'or.\n- Investissez l'or dans les améliorations : débloquez de nouveaux types d'armes ou accélez le processus de fusion.\n- Combattez les monstres et progressez dans les niveaux.\n- De temps en temps, vous croiserez des boss puissants. Les vaincre prouve votre maestrie !",
      "instructions": "- Commencez avec des armes de base et faites glisser les armes identiques pour les fusionner en versions plus puissantes.\n- Chaque nouvelle arme rapporte plus d'or.\n- Dépensez de l'or pour les améliorations : débloquez de nouveaux types d'armes ou accélérez le processus de fusion.\n- Combattez les monstres et progressez dans les niveaux.\n- De temps en temps, vous rencontrerez des boss puissants. Défeignez-les pour prouver votre maîtrise !",
      "genres": [
        "Fusionner"
      ],
      "tags": [
        "1 joueur"
      ]
    }
  }
};
